// OMNI Design System Shadow & Gradient Tokens for Chakra UI v3
// Mapped from omni_standard_css.css

export const omniShadows = {
  shadows: {
    // Basic shadow scale
    none: { value: 'none' },
    xs: { value: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' },
    sm: {
      value: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    },
    base: {
      value: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    },
    md: {
      value:
        '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    },
    lg: {
      value:
        '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    },
    xl: {
      value:
        '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    },
    '2xl': { value: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' },
    inner: { value: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)' },

    // OMNI-specific shadows (using CSS custom properties)
    'button-dark': { value: '0 4px 6px 0 rgba(0, 161, 210, 0.25)' }, // --button-shadow-dark
    'button-light': { value: '0 4px 6px 0 rgba(3, 187, 227, 0.1)' }, // --button-shadow-light
    'button-success': { value: '0 4px 6px 0 rgba(47, 240, 200, 0.25)' }, // --button-shadow-success
    'button-error': { value: '0 4px 6px 0 rgba(241, 104, 138, 0.25)' }, // --button-shadow-error
    'button-alert': { value: '0 4px 6px 0 rgba(17, 26, 32, 0.25)' }, // --button-shadow-alert

    'dropdown-tooltip': { value: '0 8px 45px -5px rgba(3, 187, 227, 0.25)' }, // --dropdown-tooltip-shadow
    calendar: { value: '0 8px 12px 0 rgba(3, 187, 227, 0.1)' }, // --calendar-shadow

    'container-level-one': {
      value: '0 10px 60px -5px rgba(3, 187, 227, 0.08)',
    }, // --container-shadow-level-one
    'container-level-two': { value: '0 17px 50px 0 rgba(3, 187, 227, 0.25)' }, // --container-shadow-level-two
    'container-level-three': {
      value: '0 24px 31px -6px rgba(3, 187, 227, 0.35)',
    }, // --container-shadow-level-three

    card: { value: '0 15px 12px -9px rgba(3, 187, 227, 0.18)' }, // --card-shadow
    'table-container': { value: '0 10px 60px -5px rgba(3, 187, 227, 0.12)' }, // --table-container-shadow

    // Bulma-style shadows for form elements
    'bulma-focus': { value: '0 0 0 0.125em rgba(0, 161, 210, 0.25)' }, // --bulma-shadow-1
    'bulma-glow': { value: '0 0 0.5em rgba(0, 161, 210, 0.25)' }, // --bulma-shadow-2
    'blue-medium': { value: '0 3px 5px 0 rgba(17, 155, 235, 0.25)' }, // --shadow-blue-med
  },

  gradients: {
    // OMNI brand gradients
    primary: {
      value:
        'linear-gradient(135deg, rgb(0, 161, 210) 0%, rgb(3, 187, 227) 100%)',
    }, // --gradient-primary
    navigation: {
      value:
        'radial-gradient(circle at 50% 0, rgb(43, 57, 82), rgb(20, 32, 51) 89%)',
    }, // --gradient-navigation

    // Status gradients
    success: { value: 'linear-gradient(138deg, #2cc4ad, #00e3ae 95%)' }, // --gradient-success
    error: { value: 'linear-gradient(137deg, #df5678 4%, #f56c8e)' }, // --gradient-error
    alert: { value: 'linear-gradient(134deg, #fed882 4%, #f8d991 95%)' }, // --gradient-alert
    info: { value: 'linear-gradient(135deg, #03bbe3 110%, #03bbe3 31%)' }, // --gradient-info

    // Alternative gradient names
    'electric-blue': {
      value:
        'linear-gradient(135deg, rgb(0, 161, 210) 0%, rgb(3, 187, 227) 100%)',
    }, // --gradient-electric-blue
    mint: { value: 'linear-gradient(138deg, #2cc4ad, #00e3ae 95%)' }, // --gradient-mint
    melon: { value: 'linear-gradient(137deg, #df5678 4%, #f56c8e)' }, // --gradient-melon
    honeycomb: { value: 'linear-gradient(134deg, #fed882 4%, #f8d991 95%)' }, // --gradient-honeycomb
    black: { value: 'radial-gradient(circle at 50% 0, #2b3952, #142033 89%)' }, // --gradient-black

    // Additional useful gradients
    'brand-to-secondary': {
      value:
        'linear-gradient(135deg, rgb(0, 161, 210) 0%, rgb(3, 187, 227) 100%)',
    },
    'brand-to-accent': {
      value:
        'linear-gradient(135deg, rgb(0, 161, 210) 0%, rgb(77, 197, 252) 100%)',
    },
    'secondary-to-accent': {
      value:
        'linear-gradient(135deg, rgb(3, 187, 227) 0%, rgb(77, 197, 252) 100%)',
    },

    // Subtle background gradients
    'subtle-blue': {
      value:
        'linear-gradient(135deg, rgba(0, 161, 210, 0.05) 0%, rgba(3, 187, 227, 0.05) 100%)',
    },
    'subtle-gray': {
      value:
        'linear-gradient(135deg, rgba(241, 245, 250, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%)',
    },
  },

  // Box shadow variations for different components
  boxShadows: {
    // Button shadows by variant
    button: {
      default: { value: '0 4px 6px 0 rgba(0, 161, 210, 0.25)' },
      primary: { value: '0 4px 6px 0 rgba(0, 161, 210, 0.25)' },
      secondary: { value: '0 4px 6px 0 rgba(3, 187, 227, 0.1)' },
      success: { value: '0 4px 6px 0 rgba(47, 240, 200, 0.25)' },
      danger: { value: '0 4px 6px 0 rgba(241, 104, 138, 0.25)' },
      warning: { value: '0 4px 6px 0 rgba(17, 26, 32, 0.25)' },
    },

    // Card shadows by elevation
    card: {
      low: { value: '0 15px 12px -9px rgba(3, 187, 227, 0.18)' },
      medium: { value: '0 10px 60px -5px rgba(3, 187, 227, 0.08)' },
      high: { value: '0 17px 50px 0 rgba(3, 187, 227, 0.25)' },
      highest: { value: '0 24px 31px -6px rgba(3, 187, 227, 0.35)' },
    },

    // Form element shadows
    form: {
      focus: { value: '0 0 0 0.125em rgba(0, 161, 210, 0.25)' },
      error: { value: '0 0 0 0.125em rgba(223, 86, 120, 0.25)' },
      success: { value: '0 0 0 0.125em rgba(44, 196, 173, 0.25)' },
    },

    // Dropdown and popover shadows
    dropdown: {
      default: { value: '0 8px 45px -5px rgba(3, 187, 227, 0.25)' },
      calendar: { value: '0 8px 12px 0 rgba(3, 187, 227, 0.1)' },
    },

    // Table shadows
    table: {
      container: { value: '0 10px 60px -5px rgba(3, 187, 227, 0.12)' },
    },
  },
};
